"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createAuthorizationContext = void 0;
const permission_store_1 = require("./permission-store");
const authorizer_1 = require("./authorizer");
function createAuthorizationContext(options = {}) {
    const permissionStore = (0, permission_store_1.createPermissionStore)({ onChange: options.onPermissionsChange });
    const authorizer = (0, authorizer_1.createAuthorizer)(permissionStore);
    return { permissionStore, authorizer };
}
exports.createAuthorizationContext = createAuthorizationContext;
//# sourceMappingURL=authorization-context.js.map